import { render, staticRenderFns } from "./UserTrips.vue?vue&type=template&id=dba94fce&scoped=true&"
import script from "./UserTrips.vue?vue&type=script&lang=js&"
export * from "./UserTrips.vue?vue&type=script&lang=js&"
import style0 from "./UserTrips.vue?vue&type=style&index=0&id=dba94fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba94fce",
  null
  
)

export default component.exports